import * as Sentry from '@sentry/browser';
import React from 'react';
import { SomethingWentWrong } from '.';

interface ErrorBoundaryState {
  error: any;
}

export class ErrorBoundary extends React.Component<React.PropsWithChildren<{}>, ErrorBoundaryState> {
  state: ErrorBoundaryState = {
    error: null,
  };

  componentDidCatch(error, errorInfo) {
    this.setState({ error });

    Sentry.withScope((scope) => {
      Object.keys(errorInfo).forEach((key) => {
        scope.setExtra(key, errorInfo[key]);
      });

      Sentry.captureException(error);
    });
  }

  render() {
    if (this.state.error) {
      return <SomethingWentWrong />;
    }

    return this.props.children;
  }
}
